import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type WeddingScheduleForEventQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
  isAdmin: Types.Scalars['Boolean'];
}>;

export type WeddingScheduleForEventQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    labels: Array<{ __typename?: 'EventLabel'; id: string; display: string; peopleCount: number; scheduleItems: Array<{ __typename?: 'EventSchedule'; id: string }> }>;
    info: {
      __typename?: 'EventInfo';
      id: string;
      schedule: {
        __typename?: 'EventScheduleInfo';
        formattedSchedules: Array<{
          __typename?: 'FormattedSchedule';
          dateISO8601TZ: string;
          items: Array<{
            __typename?: 'EventSchedule';
            description?: string | null;
            id: string;
            isPublic: boolean;
            name: string;
            timezone?: string | null;
            startTimeISO8601TZ?: string | null;
            endTimeISO8601TZ?: string | null;
            dressCode?: string | null;
            location?: string | null;
            showMap: boolean;
            placeId?: string | null;
            locationInfo?: {
              __typename?: 'EventLocation';
              id?: string | null;
              placeId?: string | null;
              latitude?: number | null;
              longitude?: number | null;
              name?: string | null;
              address1?: string | null;
              address2?: string | null;
              city?: string | null;
              state?: string | null;
              country?: string | null;
              postalCode?: string | null;
            } | null;
          }>;
        }>;
        toBeAnnouncedItems: Array<{
          __typename?: 'EventSchedule';
          description?: string | null;
          id: string;
          isPublic: boolean;
          name: string;
          timezone?: string | null;
          dressCode?: string | null;
          location?: string | null;
          showMap: boolean;
          placeId?: string | null;
          locationInfo?: {
            __typename?: 'EventLocation';
            id?: string | null;
            placeId?: string | null;
            latitude?: number | null;
            longitude?: number | null;
            name?: string | null;
            address1?: string | null;
            address2?: string | null;
            city?: string | null;
            state?: string | null;
            country?: string | null;
            postalCode?: string | null;
          } | null;
        }>;
      };
    };
  } | null;
};

export const WeddingScheduleForEventDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WeddingScheduleForEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isAdmin' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labels' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'isAdmin' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'display' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'peopleCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduleItems' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'isAdmin' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'schedule' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'formattedSchedules' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'dateISO8601TZ' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'startTimeISO8601TZ' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'endTimeISO8601TZ' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'dressCode' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'showMap' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'locationInfo' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'toBeAnnouncedItems' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'dressCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'showMap' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'locationInfo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWeddingScheduleForEventQuery__
 *
 * To run a query within a React component, call `useWeddingScheduleForEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeddingScheduleForEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeddingScheduleForEventQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      isAdmin: // value for 'isAdmin'
 *   },
 * });
 */
export function useWeddingScheduleForEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WeddingScheduleForEventQuery, WeddingScheduleForEventQueryVariables>) {
  return ApolloReactHooks.useQuery<WeddingScheduleForEventQuery, WeddingScheduleForEventQueryVariables>(WeddingScheduleForEventDocument, baseOptions);
}
export function useWeddingScheduleForEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WeddingScheduleForEventQuery, WeddingScheduleForEventQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<WeddingScheduleForEventQuery, WeddingScheduleForEventQueryVariables>(WeddingScheduleForEventDocument, baseOptions);
}
export type WeddingScheduleForEventQueryHookResult = ReturnType<typeof useWeddingScheduleForEventQuery>;
export type WeddingScheduleForEventLazyQueryHookResult = ReturnType<typeof useWeddingScheduleForEventLazyQuery>;
export type WeddingScheduleForEventQueryResult = Apollo.QueryResult<WeddingScheduleForEventQuery, WeddingScheduleForEventQueryVariables>;
